import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PageUpTimeStats } from '@models/pages/page';
import { LoaderService } from '@services/loader.service';
import { PagesService } from '@services/pages.service';
import { formateDateTime } from '@utils/utils';
import { finalize, map } from 'rxjs/operators';

@Component({
  selector: 'wsb-landing-info',
  templateUrl: './landing-info.component.html',
  styleUrls: ['./landing-info.component.scss'],
  standalone: false
})
export class LandingInfoComponent implements OnChanges {
  @Input() page: any;
  @Input() url: any;
  pageUpTime: PageUpTimeStats;
  mouseDown = false;
  startY: any;
  scrollTop: any;
  slider = document.querySelector<HTMLElement>('.parent');

  constructor(private pagesService: PagesService, private loaderService: LoaderService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.page) {
      return;
    }
    this.getPageById(this.page.idPage);
    this.getPageUpTime(this.page.idPage);
    this.onPageChange();
  }

  getPageUpTime(idPage) {
    this.pagesService.getPagesStatsGetUpTime(idPage).subscribe(upTime => {
      this.pageUpTime = upTime;
    });
  }

  getPageById(idPage) {
    this.loaderService.show();
    this.pagesService
      .getPageById(idPage)
      .pipe(
        finalize(() => this.loaderService.hide()),
        map(x => {
          const newData = x;
          newData.previewHtml = x.previewHtml.replace('%HTML_TITLE_PLACEHOLDER%', '');
          return newData;
        })
      )
      .subscribe(page => {
        this.page = page;
      });
  }

  onPageChange() {
    this.pagesService.selectionChange.subscribe(page => {
      this.getPageById(page.idPage);
      this.getPageUpTime(page.idPage);
    });
  }

  formatDate(date) {
    return formateDateTime(date);
  }

  startDragging(e, flag, el) {
    this.mouseDown = true;
    this.startY = e.pageY - el.offsetTop;
    this.scrollTop = el.scrollTop;
  }

  stopDragging(e, flag) {
    this.mouseDown = false;
  }

  moveEvent(e, el) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const y = e.pageY - el.offsetTop;
    const scroll = y - this.startY;
    el.scrollTop = this.scrollTop - scroll;
  }
}
